webpackJsonp([254572558124955],{

/***/ 807:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"8T3HZFY0CG","searchOnlyApiKey":"4b17c8e0afd4b58868a4650665933cbf","indexName":"prod_index"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-61a1ccea6d52fb2fd373.js